import { isNull } from "lodash";
import * as React from "react";
import NumberInput, { type NumberInputProps } from "./component";

export type PercentInputProps = Omit<NumberInputProps, "step">;

const PercentInput = React.forwardRef(
  ({ fractionalDigits = 2, ...props }: PercentInputProps, ref: React.RefObject<any>) => {
    const [value, setValue] = React.useState(
      props.value ? +(props.value * 100).toFixed(fractionalDigits) : props.value
    );

    React.useEffect(() => {
      setValue(props.value ? +(props.value * 100).toFixed(fractionalDigits) : props.value);
    }, [props.value, fractionalDigits]);

    const onChange = React.useCallback(
      (v: number | null) => {
        props.onChange(isNull(v) ? null : +(v / 100).toFixed(fractionalDigits + 2));
      },
      [props.onChange, fractionalDigits]
    );

    return (
      <NumberInput
        {...props}
        ref={ref}
        fractionalDigits={fractionalDigits}
        min={props.min ?? 0}
        max={props.max ?? 100}
        onChange={onChange}
        value={value}
        addon={props.addon ?? "%"}
      />
    );
  }
);

export default PercentInput;
